import { combineReducers } from "redux";
import customizer from "./customizer/";
import auth from "./auth/";
import navbar from "./navbar/Index";
import dataList from "./data-list/";
import alert from "./alert";
import form from "./form";
import user from "./user";
import ecommerce from "./ecommerce/ecommerceReducer";
import common from "./common";
import shop from "./ecommerce/shopsReducer";
import product from "./ecommerce/productReducer";
import statistics from './statistics'
import shops from './shop'
import products from './product'
import permission from './permission'
import role from './role'
import analytics from "./analytics";
import { overview } from "./ecommerce/overviewReducer";
import { customer } from "./ecommerce/customerReducer";
import driver from "./driver";



const rootReducer = combineReducers({
  customizer: customizer,
  auth: auth,
  navbar: navbar,
  dataList: dataList,
  alert: alert,
  form: form,
  user: user,
  ecommerce: ecommerce,
  ecommerceOverview:overview,
  ecommerceCustomer:customer,
  common: common,
  shop: shop,
  product: product,
  statistics:statistics,
  shops:shops,
  products:products,
  analytics:analytics,
  permission:permission,
  role:role,
  driver:driver,
});

export default rootReducer;
